import Route from '@ember/routing/route';

export default class AuthenticatedTasProgramsShowDetailsRoute extends Route {
  model() {
    return this.modelFor('authenticated.tas.programs');
  }
}
